import React from "react";
import { Container, FormControl, InputGroup } from "react-bootstrap";

import "./Banner.css";

import Search from "@mui/icons-material/Search";

const Banner = () => {
  return (
    <>
      <div className="SearchBanner">
        <Container>
          <div className="bannerContent">
            <div className="bannerDiv d-flex justify-content-center">
              <h1 className="bannerDivH1">מה את מחפשת?</h1>
            </div>
            <div className="bannerSearchDiv d-flex justify-content-center">
              <i className="fas fa-microphone microphone"></i>
              <InputGroup className="mb-3 bannerSearchDivInputGroup">
                <FormControl
                  type="search"
                  className="bannerSearchDivInput"
                  placeholder="חיפוש"
                  aria-label="Search"
                  aria-describedby="search"
                />
                <InputGroup.Text id="search">
                  <Search />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Banner;
